
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.tab-link a {
  display:block;
  border-style:none;
  padding-top:1rem;
  padding-bottom:1rem;
  padding-left:2rem;
  padding-right:2rem;
  font-weight:var(--fw-bold);
  text-decoration-line:none
}

.tab-link .inactive a {
  color:var(--primary-blue-dark)
}

.tab-link .active a {
  display:block;
  padding-left:2rem;
  padding-right:2rem;
  padding-bottom:1rem;
  font-weight:var(--fw-bold);
  color:var(--primary-blue-light-2);
  text-decoration-line:none;
  border-bottom:4px solid var(--primary-blue-light-2)
}

.tab-link a:hover {
  background-color:var(--primary-blue-light-2);
  color:var(--neutral-white);
  border-bottom:4px solid var(--primary-blue-light-2)
}
`;